import { Cross, Phone, MapPin, Clock, Instagram, Facebook, MessageCircle, Navigation } from "lucide-react";
import {
  BUSINESS,
  telHref,
  whatsappHref,
  directionsHref,
  mapsViewHref,
} from "@/data/site";
import { scrollToId } from "@/lib/scroll";

const NAV = [
  ["About", "about"],
  ["Categories", "categories"],
  ["Upload Rx", "prescription"],
  ["FAQ", "faq"],
  ["Contact", "contact"],
];

export const Footer = () => {
  return (
    <footer className="relative bg-ink text-slate-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center h-10 w-10 rounded-2xl bg-brand-green text-white">
                <Cross className="h-5 w-5" strokeWidth={2.5} />
              </span>
              <span className="leading-none">
                <span className="block font-heading font-bold text-white text-[15px] tracking-tight">
                  PALIWAL
                </span>
                <span className="block font-heading text-[11px] font-medium tracking-[0.28em] text-brand-green-light">
                  MEDICOS
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm text-slate-400 leading-relaxed">
              Your trusted neighbourhood pharmacy in Jodhpur — genuine
              medicines, honest advice and care you can count on, every single day.
            </p>
            <div className="mt-6 flex gap-3">
              {[
                { Icon: Instagram, href: "https://instagram.com" },
                { Icon: Facebook, href: "https://facebook.com" },
                { Icon: MessageCircle, href: whatsappHref },
              ].map(({ Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="grid place-items-center h-10 w-10 rounded-full bg-white/5 border border-white/10 text-slate-300 transition-colors hover:bg-brand-green hover:text-white hover:border-brand-green"
                  aria-label="social link"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-white">
              Explore
            </h4>
            <ul className="mt-5 space-y-3">
              {NAV.map(([label, id]) => (
                <li key={id}>
                  <button
                    onClick={() => scrollToId(id)}
                    className="text-sm text-slate-400 transition-colors hover:text-brand-green-light"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-white">
              Reach us
            </h4>
            <ul className="mt-5 space-y-4 text-sm text-slate-400">
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-brand-green-light shrink-0 mt-0.5" />
                <a href={mapsViewHref} target="_blank" rel="noopener noreferrer" className="hover:text-white">
                  {BUSINESS.addressShort}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-brand-green-light shrink-0" />
                <a href={telHref} className="hover:text-white">{BUSINESS.phoneDisplay}</a>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="h-4 w-4 text-brand-green-light shrink-0" />
                <span>Open Daily · {BUSINESS.hours}</span>
              </li>
              <li>
                <a
                  href={directionsHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-brand-green-light hover:text-white"
                >
                  <Navigation className="h-4 w-4" /> Open in Google Maps
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            Copyright © {new Date().getFullYear()} Paliwal Medicos. All rights reserved.
          </p>
          <p className="text-xs text-slate-500">
            Made with care in Jodhpur, Rajasthan.
          </p>
        </div>
      </div>
    </footer>
  );
};
